//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbDynamicSwiperSlide from '../../../smart-container/dynamic-swiper-slide'
import { mapGetters } from 'vuex'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
export default {
  name: 'rb-plain-slider',
  components: {
    RbDynamicSwiperSlide,
  },
  props: {
    sliderConfig: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapGetters(['translation']),
    swiperSlides() {
      return this.$slots.default.filter((slot) => !!slot.tag)
    },
    getDefaultConfig() {
      return {
        spaceBetween: this.isMobileOrTablet ? 16 : 96,
        centeredSlides: true,
        ...this.sliderConfig,
      }
    },
    isMobileOrTablet() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.reInitSwiper()
    })
  },

  methods: {
    reInitSwiper() {
      if (this.$refs.swiperRef?.swiper) {
        this.$refs.swiperRef.swiper.destroy()
        this.$nextTick(() => {
          this.$refs.swiperRef.$options.propsData.config.allowTouchMove = true
          this.$refs.swiperRef._setup()
        })
      }
    },
  },
}
